module.exports = __webpack_public_path__ + "static/media/FiresideChat.742bbb41.jpeg";